import React, { useCallback, useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { ModalHot } from 'components/common/ModalHot';
import { useDispatch } from 'react-redux';
import { getUserData } from 'redux/actions';
import { useTranslations } from 'common/hooks/useTranslations';
import GeneralModal from '../GeneralModal';

export const IframeModalHot = ({
  testID,
  open,
  onClose,
  src,
  title = 'iframe-modal',
  height = 400,
}) => {
  const dispatch = useDispatch();
  const [iframeSrc, setIframeSrc] = useState(src);
  const [openGeneralModal, setOpenGeneralModal] = useState(false);
  const [generalModalText, setGeneralModalText] = useState('');
  
  const { translate } = useTranslations();
  useEffect(() => {
    setIframeSrc(src);
  }, [src]);

  const handleIframeMessage = useCallback((e) => {
    if (e.origin === window.location.origin || e.origin.endsWith('hot.co.il')) {
      const result = e.data;
      if (result.from !== 'hot') return;

      if (result.status === 'success') {
        onClose();
        dispatch(getUserData());
      } else if (result.status === 'failed') {
        setOpenGeneralModal(true);
        setGeneralModalText(result.description.length > 0 ? result.description : translate('add_credit_card_failure_message'));
        if (result.url) {
          setIframeSrc(result.url);
        }
      } else if (result.description) {
        setOpenGeneralModal(true);
        setGeneralModalText(result.description);
      }
    }
  }, [dispatch, onClose]);

  useEffect(() => {
    if (open) {
      window.addEventListener('message', handleIframeMessage, false);
      return () => {
        window.removeEventListener('message', handleIframeMessage, false);
      };
    }
  }, [open, handleIframeMessage]);

  return (
    <ModalHot
      testID={testID}
      open={open}
      onClose={onClose}
    >
      <Box
        sx={{
          width: '100%',
          minHeight: height,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {iframeSrc ? (
          <iframe
            src={iframeSrc}
            title={title}
            style={{
              width: '100%',
              height,
              border: 'none',
            }}
          />
        ) : (
          <CircularProgress />
        )}
      </Box>

      <GeneralModal
        open={openGeneralModal}
        onClose={() => {
          setOpenGeneralModal(false);
        }}
        buttonText={translate('terms_popup_ok_btn')}
        onButtonClick={() => {
          setOpenGeneralModal(false);
        }}
      >
        {generalModalText}
      </GeneralModal>
    </ModalHot>
  );
};

export default IframeModalHot;